module.exports = __webpack_public_path__ + "img/picture7.3745fa44.png";